export default __webpack_public_path__ + "static/media/oxford.9cafa98d.png";